var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lh-1" }, [
    _c("div", { staticClass: "b_gray2 mar20-b" }, [
      _c(
        "div",
        { staticClass: "wrap flex items-center nav" },
        [
          _c(
            "el-breadcrumb",
            {
              staticClass: "flex1",
              attrs: { "separator-class": "el-icon-arrow-right" }
            },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("活动管理")]),
              _c("el-breadcrumb-item", [_vm._v("活动列表")]),
              _c("el-breadcrumb-item", [_vm._v("活动详情")])
            ],
            1
          ),
          _c("div", { staticClass: "red radius4 bor_red pad10-lr f12 store" }, [
            _vm._v("厂家品牌店")
          ]),
          _c("div", { staticClass: "mar20-l mar10-r" }, [
            _vm._v("哼哼动保旗舰店")
          ]),
          _c("el-rate", {
            staticClass: "rate",
            attrs: { value: "5", disabled: "" }
          }),
          _vm._m(0),
          _c("div", { staticClass: "pointer" }, [_vm._v("关注店铺")]),
          _c("div", { staticClass: "pointer mar30-l" }, [_vm._v("进店逛逛")])
        ],
        1
      )
    ]),
    _c("div", { staticClass: "flex wrap info" }, [
      _c("div", { staticClass: "w350" }, [
        _c("div", { staticClass: "border ellipsis goods-img" }, [
          _c("img", {
            attrs: { src: _vm.goodsImg + "?imageView2/1/w/350/h/350" }
          })
        ]),
        _c("div", { staticClass: "flex ellipsis mar20-tb goods-img-list" }, [
          _c("img", {
            staticClass: "pointer",
            attrs: { src: require("./images/btn_left.png") }
          }),
          _c(
            "ul",
            { staticClass: "flex flex1 mar20-lr ul-cls ellipsis imgs" },
            [
              _c("li", { staticClass: "ellipsis image100 mar20-r" }, [
                _c("img", {
                  attrs: { src: _vm.goodsImg + "?imageView2/1/w/48/h/48" }
                })
              ]),
              _c("li", { staticClass: "ellipsis image100 mar20-r active" }, [
                _c("img", {
                  attrs: { src: _vm.goodsImg + "?imageView2/1/w/48/h/48" }
                })
              ])
            ]
          ),
          _c("img", {
            staticClass: "pointer",
            attrs: { src: require("./images/btn_right.png") }
          })
        ]),
        _vm._m(1)
      ]),
      _c("div", { staticClass: "flex1 mar30-lr" }, [
        _vm._m(2),
        _c("div", { staticClass: "ellipsis mar15-t mar20-b red" }, [
          _vm._v("电磨机 迷你小型玉石蜜蜡雕刻机 电动打磨抛光工具多功能家用电钻")
        ]),
        _vm._m(3),
        _c("img", {
          staticClass: "mar20-t",
          attrs: { src: require("./images/medicine.png") }
        }),
        _c("img", {
          staticClass: "mar10-t",
          attrs: { src: require("./images/ad.png") }
        }),
        _vm._m(4),
        _vm._m(5),
        _vm._m(6),
        _vm._m(7),
        _c(
          "div",
          { staticClass: "flex items-center gray_2 mar20-t" },
          [
            _c("div", { staticClass: "f16 w82" }, [_vm._v("数量")]),
            _c("el-input-number", { attrs: { size: "mini", value: "1" } }),
            _c("div", { staticClass: "mar30-l" }, [_vm._v("数量剩余32件")])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mar30-tb text-center" },
          [
            _c(
              "el-button",
              {
                staticClass: "w140 f16 fb mar20-r",
                attrs: { type: "primary" }
              },
              [_vm._v(" 立即购买 ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "w140 f16 fb",
                attrs: { type: "primary", plain: "" }
              },
              [_vm._v(" 加入进货车 ")]
            )
          ],
          1
        )
      ]),
      _vm._m(8)
    ]),
    _c("div", { staticClass: "b_gray2 mar30-b" }, [
      _c("div", { staticClass: "gray_2 lh-50 flex wrap" }, [
        _vm._m(9),
        _c("div", { staticClass: "flex flex1 text-center tabs" }, [
          _c(
            "div",
            {
              staticClass: "tab pointer",
              class: { active: _vm.tabsActive === 0 },
              on: {
                click: function($event) {
                  _vm.tabsActive = 0
                }
              }
            },
            [_vm._v("货品介绍")]
          ),
          _c(
            "div",
            {
              staticClass: "tab pointer",
              class: { active: _vm.tabsActive === 1 },
              on: {
                click: function($event) {
                  _vm.tabsActive = 1
                }
              }
            },
            [_vm._v("货品属性")]
          ),
          _c(
            "div",
            {
              staticClass: "tab pointer",
              class: { active: _vm.tabsActive === 2 },
              on: {
                click: function($event) {
                  _vm.tabsActive = 2
                }
              }
            },
            [_vm._v("评论")]
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "flex wrap" }, [
      _c(
        "div",
        { staticClass: "border w248 mar20-r store-info" },
        [
          _c("div", { staticClass: "box60" }),
          _vm._m(10),
          _c("div", { staticClass: "box50" }),
          _c("div", { staticClass: "text-center pad20-lr" }, [
            _vm._v("哼哼动保旗舰店")
          ]),
          _c("el-rate", {
            staticClass: "text-center mar10-tb",
            attrs: { value: "5", disabled: "" }
          }),
          _c(
            "div",
            { staticClass: "text-center mar10-lr" },
            [
              _c(
                "el-tag",
                {
                  staticClass: "mar20-r mar20-b info-tag",
                  attrs: { type: "danger" }
                },
                [_vm._v(" 厂家直营店 ")]
              ),
              _c(
                "el-tag",
                { staticClass: "mar20-b info-tag", attrs: { type: "warning" } },
                [_vm._v(" 核心企业旗舰店 ")]
              )
            ],
            1
          ),
          _c("div", { staticClass: "border-t border-b pad20" }, [
            _vm._m(11),
            _vm._m(12),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "f14",
                    attrs: {
                      round: "",
                      type: "primary",
                      size: "small ",
                      icon: "el-icon-plus"
                    }
                  },
                  [_vm._v(" 关注 ")]
                ),
                _c("div", { staticClass: "box20" }),
                _c("a", { attrs: { href: "#" } }, [_vm._v("进入店铺>")])
              ],
              1
            )
          ]),
          _vm._m(13)
        ],
        1
      ),
      _vm.tabsActive === 0 ? _c("div", [_vm._v("货品介绍")]) : _vm._e(),
      _vm.tabsActive === 1 ? _c("div", [_vm._v("货品属性")]) : _vm._e(),
      _vm.tabsActive === 2 ? _c("div", [_vm._v("评论")]) : _vm._e()
    ]),
    _c("div", { staticClass: "box30" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex pointer items-center mar30-lr" }, [
      _c("div", { staticClass: "mar10-r" }, [_vm._v("联系客服")]),
      _c("img", { attrs: { src: require("./images/service.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "flex pointer red" }, [
        _c("img", {
          staticClass: "mar10-r",
          attrs: { src: require("./images/favorite.png") }
        }),
        _vm._v("收藏（10）")
      ]),
      _c("div", { staticClass: "flex-auto mar20-lr" }, [
        _vm._v("累计销量20件")
      ]),
      _c("div", { staticClass: "pointer" }, [_vm._v("生成二维码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f16 ellipsis_two goods_title" }, [
      _c("span", { staticClass: "red f14 mar10-r tag" }, [_vm._v("自营")]),
      _c("span", { staticClass: "white f14 mar10-r tag plain" }, [
        _vm._v("优选")
      ]),
      _vm._v(
        "\n        电磨机迷你小型玉石蜜蜡雕刻机电动打磨抛光工具多功能家用电钻电动打磨抛光工具多功能家用电钻\n        电磨机迷你小型玉石蜜蜡雕刻机电动打磨抛光工具多功能家用电钻电动打磨抛光工具多功能家用电钻\n      "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "b_gray2 pad20" }, [
      _c("div", { staticClass: "flex items-baseline mar20-b" }, [
        _c("div", { staticClass: "gray_2 f16 w82" }, [_vm._v("价格")]),
        _c("div", { staticClass: "red f24 arial" }, [_vm._v("¥45.22")])
      ]),
      _c("div", { staticClass: "flex items-center" }, [
        _c("div", { staticClass: "gray_2 f16 w82" }, [_vm._v("优惠")]),
        _c("img", { attrs: { src: require("./images/coupon.png") } }),
        _c("div", { staticClass: "mar20-lr" }, [_vm._v("满100元减20元")]),
        _c("div", { staticClass: "mar10-r" }, [_vm._v("满500元减100元")]),
        _c("a", { staticClass: "red", attrs: { href: "#" } }, [
          _vm._v("点击领取")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center gray_2 mar25-t" }, [
      _c("div", { staticClass: "f16 w82" }, [_vm._v("配送方式")]),
      _c("div", { staticClass: "flex1" }, [_vm._v("买家自提")]),
      _c("div", { staticClass: "pointer" }, [
        _vm._v("查看地址"),
        _c("i", { staticClass: "el-icon-caret-bottom" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center gray_2 mar25-t" }, [
      _c("div", { staticClass: "f16 w82" }, [_vm._v("送至地址")]),
      _c("div", { staticClass: "mar20-r pointer tag" }, [_vm._v("北京市")]),
      _c("div", [_vm._v("该地区不支持配送")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center gray_2 mar25-t" }, [
      _c("div", { staticClass: "f16 w82" }, [_vm._v("运费")]),
      _c("div", [_vm._v("¥14")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center gray_2 mar25-t" }, [
      _c("div", { staticClass: "f16 w82" }, [_vm._v("规格")]),
      _c("div", { staticClass: "mar20-r pointer tag" }, [_vm._v("元/支")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "f16 self-start radius5 border pad30-lr pad20-tb right" },
      [
        _c("div", { staticClass: "text-center" }, [_vm._v("大家都在看")]),
        _c(
          "a",
          {
            staticClass: "block border-b pad20-tb item",
            attrs: { href: "#", target: "_blank" }
          },
          [
            _c("div", { staticClass: "img ellipsis radius4 image100" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://filesouthcdn.nxin.com/nxsc_159557040299406260187077045155.JPEG?imageView2/1/w/140/h/140"
                }
              })
            ]),
            _c("div", { staticClass: "mar20-t ellipsis" }, [
              _vm._v("电磨机迷你小型电磨机迷你小型")
            ]),
            _c("div", { staticClass: "red mar10-t arial" }, [
              _c("span", { staticClass: "f14" }, [_vm._v("¥")]),
              _c("span", { staticClass: "f18" }, [_vm._v("45.22")])
            ])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "block border-b pad20-tb item",
            attrs: { href: "#", target: "_blank" }
          },
          [
            _c("div", { staticClass: "img ellipsis radius4 image100" }, [
              _c("img", {
                attrs: {
                  src:
                    "https://filesouthcdn.nxin.com/nxsc_159557040299406260187077045155.JPEG?imageView2/1/w/140/h/140"
                }
              })
            ]),
            _c("div", { staticClass: "mar20-t ellipsis" }, [
              _vm._v("电磨机迷你小型电磨机迷你小型")
            ]),
            _c("div", { staticClass: "red mar10-t arial" }, [
              _c("span", { staticClass: "f14" }, [_vm._v("¥")]),
              _c("span", { staticClass: "f18" }, [_vm._v("45.22")])
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex w270" }, [
      _c("div", { staticClass: "mar30-r" }, [_vm._v("哼哼动保旗舰店")]),
      _c("div", { staticClass: "mar20-r" }, [_vm._v("联系客服")]),
      _c("img", {
        staticClass: "self-center",
        attrs: { src: require("./images/service.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("img", { attrs: { src: require("./images/logo.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center" }, [
      _c("div", { staticClass: "f16" }, [_vm._v("主营：")]),
      _c("div", [_vm._v("动保")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mar20-tb items-center" }, [
      _c("div", { staticClass: "f16" }, [_vm._v("地址：")]),
      _c("div", [_vm._v("湖北省武汉市洪山区")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad20" }, [
      _c("div", { staticClass: "f16" }, [_vm._v("货品分类")]),
      _c("div", { staticClass: "mar20-t text-center" }, [
        _vm._v("暂无货品分类")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }